import { defineComponent as _defineComponent } from 'vue';
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "icon"
};
import { ref, watchEffect } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'named-icon',
    props: {
        name: {}
    },
    setup(__props) {
        const iconName = ref(null);
        watchEffect(() => {
            if (typeof __props.name === 'string')
                iconName.value = __props.name;
            else
                __props.name.then((name) => iconName.value = name ?? null);
        });
        return (_ctx, _cache) => {
            return (iconName.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                    _createElementVNode("use", _normalizeProps(_guardReactiveProps({ 'xlink:href': `#${iconName.value}` })), null, 16)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
